export default function setMaskSliceView(sliceView) {
  return (notify, getSceneState) => {
    const { mask } = getSceneState();

    mask.material.setSliceView(sliceView);

    notify();
  };
}
